import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { BaseRepository } from '@interfaces/base-repository';

@Component({
  selector: 'app-autocomplete-text',
  templateUrl: './autocomplete-text.component.html',
  styleUrls: ['./autocomplete-text.component.scss']
})
export class AutocompleteTextComponent implements OnInit {
  @Input() list: string[];
  @Input() control: UntypedFormControl;
  @Input() label: string;
  @Input() errorMsg: string;
  @Input() number: number;
  @Input() isFilter: boolean;

  @Output() selectedOptionForFilter = new EventEmitter<any>();
  @Output() changeEvent = new EventEmitter<void>();

  filteredList: Observable<string[]>;

  constructor() { }

  ngOnInit() {
    this.setfilters();
    if (this.list?.length === 1) {
      this.control.setValue(this.list[0]);
    }
  }

  onChange() {
    this.changeEvent.next();
  }

  private setfilters(): void {
    let validators = [];

    if (this.control.validator) {
      validators.push(this.control.validator);
    }

    this.control.setValidators(validators);


    this.filteredList = this.control.valueChanges
      .pipe(
        startWith(''),
        map((value: string) => value ? this.filter(value) : this.list.slice())
      );
  }

  private filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.list.filter(item => item.includes(filterValue));
  }
}
